import { onBeforeUnmount, watch } from 'vue';
import { useAuth } from '@/shared/composables/useAuth';
import { useProjectStore } from '@/shared/stores/project';

const TEN_MINUTES_MS = 10 * 60 * 1000;
let intervalId: ReturnType<typeof setInterval> | null = null;

export function useProjectCacheInvalidation() {
  const auth = useAuth();
  const projectStore = useProjectStore();

  const stopInterval = () => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const runInvalidation = async (): Promise<void> => {
    if (!auth.isAuthenticated.value) return;
    projectStore.resetSelectionValidation();
    await projectStore.validateSelectedProjectExists();
  };

  const startInterval = () => {
    if (intervalId !== null) return;
    intervalId = setInterval(() => {
      void runInvalidation();
    }, TEN_MINUTES_MS);
  };

  watch(
    auth.isAuthenticated,
    (isAuthenticated) => {
      if (isAuthenticated) {
        void runInvalidation();
        startInterval();
      } else {
        stopInterval();
      }
    },
    { immediate: true }
  );

  onBeforeUnmount(() => {
    stopInterval();
  });

  return {
    runInvalidation,
  };
}
